/**
 * AI APIs provider presentation (A7Y-5559): label, colour and console links
 * come from `AI_API_PROVIDERS` in `@a7y/types` (read through `./meta`), so the
 * API, the snapshot job and these pages agree on one registry; this file adds
 * the glyph.
 *
 * Not `autobuild/quota-account-parts.tsx`'s `ProviderIcon`: that one is typed
 * to the Claude/Codex subscription accounts, which this section never shows.
 */
import { Bot, Gem, Search, Sparkles, type LucideIcon } from 'lucide-react';
import { AI_API_PROVIDERS, type AiApiProvider } from '@a7y/types';

const GLYPHS: Record<AiApiProvider, LucideIcon> = {
  anthropic: Sparkles,
  openai: Bot,
  gemini: Gem,
  perplexity: Search,
};

export function ProviderGlyph({
  provider,
  className = 'h-5 w-5',
}: {
  provider: AiApiProvider;
  className?: string;
}) {
  const Icon = GLYPHS[provider];
  const { colorHex, label } = AI_API_PROVIDERS[provider];
  return (
    <span
      className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md"
      style={{ backgroundColor: `${colorHex}1f`, color: colorHex }}
      aria-hidden="true"
      title={label}
    >
      <Icon className={className} />
    </span>
  );
}
